import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, RefreshCw } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-[75vh] flex items-center justify-center px-4 py-12 bg-gradient-to-b from-gray-50 to-gray-100">
      <motion.div 
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="max-w-md w-full bg-white rounded-3xl p-8 shadow-xl text-center border border-gray-100 relative overflow-hidden"
      >
        {/* Glow backdrop */}
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-red-500/10 rounded-full blur-2xl pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-blue-500/10 rounded-full blur-2xl pointer-events-none" />

        <div className="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-black shadow-inner">
          404
        </div>

        <h1 className="text-2xl sm:text-3xl font-black text-gray-900 mb-2 tracking-tight">
          Page Not Found
        </h1>

        <p className="text-gray-500 text-sm mb-8 leading-relaxed font-medium">
          The show, seat map, or page you are looking for does not exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="bg-[#ef2b2d] hover:bg-red-700 text-white font-bold py-3 px-6 rounded-2xl flex items-center justify-center gap-2 shadow-md hover:shadow-red-500/25 transition-all text-sm"
          >
            <Home size={18} />
            <span>Go to Homepage</span>
          </Link>
          <button
            onClick={() => window.location.reload()}
            className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold py-3 px-5 rounded-2xl flex items-center justify-center gap-2 transition-all text-sm"
          >
            <RefreshCw size={16} />
            <span>Reload</span>
          </button>
        </div>
      </motion.div>
    </div>
  );
}
